import { Controller } from '@hotwired/stimulus'

// Auto-derives a URL slug from the post title when the customer
// hasn't hand-typed one. Fires on title-field blur. Stays out of
// the way once the slug field has any value — we don't clobber a
// customer-tuned URL.
//
// Usage in an ERB form:
//   <div data-controller="blog-slug">
//     <input data-blog-slug-target="title"
//            data-action="blur->blog-slug#fillFromTitle">
//     <input data-blog-slug-target="slug">
//   </div>
export default class extends Controller {
  static targets = ['title', 'slug']

  fillFromTitle() {
    if (!this.hasSlugTarget || !this.hasTitleTarget) return
    if (this.slugTarget.value && this.slugTarget.value.trim() !== '') return

    const slug = this.titleTarget.value
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 80)

    this.slugTarget.value = slug
  }
}
